import { useEffect, useState } from "react";
import { FaTrash } from "../../../../assets/icons/vander";
import { useWorkShiftStore, useForm } from "../../../../hooks";
import { InputForm, SelectForm } from "../../../ui";

const formValidations = {};

export const WorkShiftFilterForm = () => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    doctorsSelect,
    shiftTypes,
    params,
    workShifts,

    // Methods
    getDoctorsBySelect,
    startWorkShiftFilter,
    startResetParams,
  } = useWorkShiftStore();

  // States ------------------------------------------------//
  const [formData, setFormData] = useState(params);

  // Formulario --------------------------------------------//
  const { formState, onInputChange } = useForm(formData, formValidations);

  // Funciones ---------------------------------------------//
  const onSubmit = () => {
    startWorkShiftFilter(formState);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (doctorsSelect.data.length === 0) {
      getDoctorsBySelect();
    }
  }, [doctorsSelect.data, getDoctorsBySelect]);

  useEffect(() => {
    setFormData(params);
  }, [params]);

  return (
    <div className="card">
      <div className="card-header border-top border-2 fw-bold">Filtros</div>
      <div className="card-body">
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-4">
              <SelectForm
                label={"Doctor"}
                sublabel={"Campo opcional"}
                options={doctorsSelect.data}
                labelKey={"name"}
                name={"doctorId"}
                value={formState.doctorId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <SelectForm
                label={"Tipo de jornada"}
                sublabel={"Campo opcional"}
                options={shiftTypes}
                labelKey={"label"}
                name={"shiftType"}
                value={formState.shiftType}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <InputForm
                label={"Fecha incial"}
                sublabel={"Campo opcional"}
                type={"date"}
                placeholder={"Fecha"}
                name={"startDate"}
                value={formState.startDate}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-4">
              <InputForm
                label={"Fecha final"}
                sublabel={"Campo opcional"}
                type={"date"}
                placeholder={"Fecha"}
                name={"endDate"}
                value={formState.endDate}
                onInputChange={onInputChange}
              />
            </div>
          </>
          <div className="col-md-12">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => onSubmit()}
              disabled={workShifts.isLoading}
            >
              Filtrar
            </button>
            <button
              className="btn btn-icon btn-pills btn-warning ms-2"
              onClick={() => startResetParams()}
              disabled={workShifts.isLoading}
            >
              <FaTrash className="icons" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
